import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import AxiosController from '../../../authentication/AxiosController';
import { Container, Modal } from 'react-bootstrap';
import Loader from '../../../loader/Loader';
import { toast } from 'react-toastify';

const ConfirmationCountry = () => {
    const { slug, lang } = useParams();
    const [_] = useTranslation('global');
    const [data, setData] = useState(null);
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        user_id: '',
        is_available: 1
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await AxiosController.get(`/api/${slug}/${lang}/confirmation-country`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setData(response.data);
            setLoading(false);
        } catch (err) {
            setError(err.message);
            toast.error(err.response?.data?.error || err.message);
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await AxiosController.post(`/api/${slug}/${lang}/confirmation-country`, formData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setShowModal(false);
            setFormData({ user_id: '', is_available: 1 });
            fetchData(); // Refresh the data
        } catch (err) {
            toast.error(err.response?.data?.message || 'Error creating confirmation country');
        }
    };

    const handleStatusChange = async (id, newStatus, user_id) => {
        try {
            await AxiosController.post(`/api/ae/en/confirmation-country/${id}/toggle`, {
                is_available: newStatus,
                user_id: user_id
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchData(); // Refresh the data after update
        } catch (err) {
            console.error('Error updating status:', err);
            toast.error(err.response?.data?.error || 'Error updating status');
        }
    };

    if (error) return <div className="p-4 text-danger">Error: {error}</div>;

    return (
        <Container style={{ position: "relative" }}>
            <Loader active={loading} />

            <button
                style={{ background: 'rgb(89, 198, 201)', color: 'white', border: 'none' }}
                className="btn btn-primary px-4 d-flex align-items-center gap-2"
                onClick={() => {
                    setShowModal(true);
                }}
            >
                <i className="fas fa-plus"></i>
                {_('panel.add')}
            </button>            <h3 className="my-4 fs-1 " style={{ color: "rgb(89, 198, 201)" }}>{_('panel.confirmation_country')}</h3>
            <div
                style={{ borderRadius: "40px" }}
                className={`table-responsive border my-3 d-flex ${lang === "en" ? "flex-row" : "flex-row-reversed"} align-items-center`}
            >

                {data && (

                    <table className="table table-borderless" htmlFor="flexCheckDefault">
                        <thead >
                            <tr style={{ textAlign: 'center' }}   >
                                <th className=" align-middle   ">{_('panel.employee')}</th>
                                <th className=" align-middle">{_('panel.country')}</th>
                                <th className=" align-middle">{_('panel.status')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item) => (
                                <tr key={item.id}>
                                    <td >
                                        <div className="d-flex flex-column justify-content-center align-items-center ">


                                            <div className="fw-medium">{`${item.user.id} `}#</div>
                                            <div className="fw-medium">{`${item.user.first_name} ${item.user.last_name}`}</div>
                                            <div className="text-muted small">{item.user.email}</div>
                                            <div className="text-muted small">{item.user.phone_number}</div>

                                        </div>
                                    </td>
                                    <td >
                                        <span className="fw-medium">{item.currency.country}</span>
                                    </td>
                                    <td >
                                        <div className="d-flex justify-content-center align-items-center">
                                            <select
                                                className={`form-select  form-select-sm ${item.is_available ? 'border-success' : 'border-danger'}`}
                                                value={item.is_available}
                                                onChange={(e) => handleStatusChange(item.id, parseInt(e.target.value), item.user_id)}
                                                style={{ width: 'auto', minWidth: '120px' }}
                                            >
                                                <option value={1}>{_('panel.available')}</option>
                                                <option value={0}>{_('panel.unavailable')}</option>
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                )}

            </div>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                className="custom-modal"
            >
                <Modal.Header closeButton className="border-bottom-0 pb-0">
                    <Modal.Title className="h5">{_('panel.add_confirmation_country')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-4">
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <label className="form-label fw-medium">{_('panel.employee')}</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={_('panel.employee')}
                                value={formData.user_id}
                                onChange={(e) => setFormData({ ...formData, user_id: e.target.value })}
                                required
                            />

                        </div>
                        <div className="mb-4">
                            <label className="form-label fw-medium">{_('panel.status')}</label>
                            <select
                                className="form-select form-select"
                                value={formData.is_available}
                                onChange={(e) => setFormData({ ...formData, is_available: parseInt(e.target.value) })}
                            >
                                <option value={1}>{_('panel.available')}</option>
                                <option value={0}>{_('panel.unavailable')}</option>
                            </select>
                        </div>
                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <button
                                type="button"
                                className="btn btn-light px-4"
                                onClick={() => setShowModal(false)}
                            >
                                {_('panel.cancel')}
                            </button>
                            <button
                                style={{ background: 'rgb(89, 198, 201)', color: 'white', border: 'none' }}
                                type="submit" className="btn px-4"
                            >
                                {_('panel.save')}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

        </Container>
    );
};

export default ConfirmationCountry; 